import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z"
}), 'DesktopMacOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DesktopMacOutlined.js
// module id = 3104
// module chunks = 2